import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { AuthContext } from "./AuthContext";
import "./Login.css";
import Header from "../../layout/Header/Header";

const Login = () => {
    const [credentials, setCredentials] = useState({ username: "", password: "" });
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { login } = useContext(AuthContext);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (credentials.username === "admin" && credentials.password === "password") {
            login(); // Actualiza el estado de autenticación en AuthContext
            navigate("/perca"); // Redirige a la ruta protegida
        } else {
            setError("Credenciales incorrectas");
        }
    };

    return (
        <>
            <Header />
            <div className="login-page-container">
                <div className="login-card">
                    <h2 className="login-title">Iniciar Sesión</h2>
                    {error && <p className="login-error-message">{error}</p>}
                    <form onSubmit={handleSubmit} className="login-form">
                        {/* Campo de Usuario */}
                        <div className="login-input-group">
                            <FaEnvelope className="login-input-icon" />
                            <input
                                type="text"
                                id="username"
                                name="username"
                                className="login-input-field"
                                placeholder="Usuario"
                                value={credentials.username}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Campo de Contraseña */}
                        <div className="login-input-group">
                            <FaLock className="login-input-icon" />
                            <input
                                type="password"
                                id="password"
                                name="password"
                                className="login-input-field"
                                placeholder="Contraseña"
                                value={credentials.password}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Botón de Inicio de Sesión */}
                        <button type="submit" className="login-submit-button">
                            Iniciar Sesión
                        </button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Login;
